const text = {
  cat: {
    menu: {
      titol: 'Inici',
      inici: 'Inici',
      dashboard: 'Dashboard',
      informes: 'Informes',
      usuaris: 'Usuaris',
      clients: 'Clients',
      parametresClients: 'Paràmetres Clients',
      informesConfig: 'Informes',
      configuracio: 'Configuració',
      descargarApp: 'Descarregar app',
      conexions: 'Monitorització'
    },
    conexions: {
      titol: 'Connexions',
      subtitol: 'Estat de connexió dels Hubs de cada client',
      cliente: 'Client',
      alias: 'Alias',
      estado: 'Estat',
      conectado: 'Connectat',
      desconectado: 'Desconnectat',
      numConexiones: 'Núm. connexions',
      totalConexiones: 'clients connectats',
      refrescar: 'Refrescar',
      errorLoad: 'Error en carregar les connexions',
      empty: 'No hi ha clients amb Hub configurat',
      horaCache: 'Hora de precàlcul',
      guardarHora: 'Desar hora',
      horaGuardada: 'Hora desada correctament',
      errorGuardarHora: 'Error en desar l\'hora',
      ejecutarAra: 'Executar precàlcul ara',
      ejecucionLanzada: 'Precàlcul llançat en segon pla',
      errorEjecutar: 'Error en llançar el precàlcul',
      ultimaEjecucion: 'Última execució',
      ok: 'OK',
      error: 'Error',
      sinConfigurar: 'Sense configurar',
      activo: 'Actiu',
      inactivo: 'Inactiu',
      activarProgramacion: 'Activar/desactivar programació',
      eliminarProgramacion: 'Eliminar programació',
      confirmarEliminar: 'Segur que vols eliminar la programació diària de {nombre}? Es deixaran de precalcular les seves consultes automàticament.',
      eliminar: 'Eliminar',
      cancelar: 'Cancel·lar',
      programacionEliminada: 'Programació eliminada correctament',
      errorEliminar: 'Error en eliminar la programació',

      // Versio de l'exe del HUB
      monVersioHub: 'Versio del HUB',
      monVersioHubHint: 'Exe que han de tenir tots els clients',
      verVersioActiva: 'Versio activa',
      verPublicadaEl: 'Publicada el',
      verHubsAlDia: 'Hubs al dia',
      verHubsAlDiaHint: 'Ja corren la versio activa',
      verHubsEndarrerits: 'Hubs endarrerits',
      verHubsEndarreritsHint: 'S\'actualitzaran sols',
      verHubsDesconeguts: 'Sense reportar',
      verHubsDesconegutsHint: 'Encara no han dit quina versio porten',
      verPublicarNova: 'Publicar una versio nova',
      verHistorial: 'Historial de versions',
      verVersio: 'Versio',
      verDesconeguda: 'Desconeguda',
      verAlDia: 'Al dia',
      verEndarrerit: 'Endarrerit',
      verActiva: 'Activa',
      verCapPublicada: 'Cap versio publicada',
      verNumero: 'Numero de versio',
      verNotes: 'Notes',
      verNotesPlaceholder: 'Que hi ha de nou',
      verFitxer: 'Fitxer .exe',
      verTriaFitxer: 'Triar fitxer...',
      verPujar: 'Publicar',
      verPujant: 'Pujant...',
      verPujada: 'Versio publicada. Els Hubs connectats ja han estat avisats.',
      verErrorPujar: 'Error en publicar la versio',
      verData: 'Data',
      verMida: 'Mida',
      verActivar: 'Tornar a aquesta versio',
      verActivada: 'Versio activada',
      verConfirmarActivar: 'Tornar a la versio {version}? Tots els Hubs hi tornaran sols. Es la manera de desfer una versio que ha sortit dolenta.',
      verEsborrar: 'Esborrar',
      verConfirmarEsborrar: 'Esborrar la versio {version} del servidor? Si algun dia hi vols tornar, hauras de pujar-la un altre cop.',
      verAvis: 'En publicar, tots els Hubs es descarregaran aquest exe i es reiniciaran sols. Deixa el numero de versio igual que el de version.py.',

      // Monitorització i dimensionament del servei
      monTitol: 'Monitorització',
      monSubtitol: 'Dimensionament del servei i estat del maquinari',
      monDimensionament: 'Dimensionament del servei',
      monMaquinari: 'Maquinari del servidor',
      monMaquinariHint: 'Indica si encara es poden pujar els límits',
      monConnexions: 'Connexions dels Hubs',
      monWorkers: 'Workers',
      monHubs: 'Hubs connectats',
      monRedis: 'Redis',
      monRedisActiu: 'Actiu',
      monRedisInactiu: 'Inactiu',
      monMysqlAra: 'Connexions MySQL ara',
      monVariable: 'Variable',
      monValor: 'Valor actual',
      monRecomanat: 'Recomanat',
      monEstat: 'Estat',
      monIndicador: 'Indicador',
      monLlindar: 'Llindar',
      monTotCorrecte: 'Tot correcte',
      monCritics: 'crítics',
      monAvisos: 'avisos',
      monPerque: 'Per què és important',
      monCom: 'Com es modifica',
      monLoadAverage: 'Load average (1 / 5 / 15 min)',
      monNuclis: 'nuclis',
      monMemoria: 'Memòria',
      monSwap: 'Swap',
      monDisc: 'Disc',
      monLliures: 'lliures',
      monErrorLoad: 'Error en carregar el dimensionament',
      monSensePermis: 'No tens permisos per veure aquesta secció',
      monActualitzacions: 'Actualitzacions',
      monActualitzacionsHint: 'Vistes i funcions creades a la base de dades de cada client',
      monClient: 'Client',
      monAlDia: 'al dia',
      monAmbProblemes: 'amb problemes',
      monActOk: 'Correctes',
      monActPendents: 'Pendents',
      monUltimaExecucio: 'Darrera execució',
      monMai: 'Mai',
      monExecutarAra: 'Executar ara',
      monReiniciar: 'Marcar per reexecutar',
      monReiniciarConfirm: 'Es marcaran TOTES les actualitzacions d\'aquest client per tornar-les a aplicar, incloses les que ja són correctes. Vols continuar?',
      monHubDesconnectat: 'El HUB no està connectat',
      monErrorActualitzacions: 'Error en carregar l\'estat de les actualitzacions',
      monExecutadesOk: 'Actualitzacions executades',
      monMarcadesOk: 'Actualitzacions marcades per reexecutar',
      monSenseDetall: 'Cap actualització pendent',
      monDesplega: 'Desplegar',
      monReplega: 'Replegar',
      monAlertaTitol: 'Rendiment del servei',
      monAlertaMissatge: 'El rendiment del servei està arribant al límit.',
      monAlertaCritic: 'Hi ha paràmetres del servei en estat crític.',
      monAlertaAfectats: 'Paràmetres afectats',
      monAlertaVeure: 'Veure el detall',
      monAlertaMesTard: 'Ara no',
      estatOk: 'OK',
      estatAvis: 'Avís',
      estatCritic: 'Crític',
      estatInfo: 'Info'
    },
    config: {
      titol: 'Configuració',
      cardTitle: 'Configuració',
      namePlaceholder: 'Nom de la configuració',
      jsonPlaceholder: 'Introduïu el JSON de configuració',
      logoPlaceholder: 'Inserta imatge del logo',
      faviconPlaceholder: 'Inserta imatge del favicon',
      saveButton: 'Desar',
      resetButton: 'Restablir',
      errorLoad: 'Error en carregar la configuració',
      successUpdated: 'Configuració actualitzada',
      errorUpdate: 'Error en actualitzar la configuració'
    },
    profile: {
      title: 'El Meu Perfil',
      personalInfo: 'Informació Personal',
      personalization: 'Personalització',
      language: 'Idioma',
      security: 'Seguretat',
      username: "Nom d'usuari",
      fullName: 'Nom complet',
      email: 'Correu electrònic',
      themeLabel: 'Tema de la consola',
      languageLabel: 'Idioma de la interfície',
      currentThemeColors: 'Colors del tema actual',
      principal: 'Principal',
      secondary: 'Secundari',
      details: 'Detalls',
      headers: 'Headers',
      password: 'Contrasenya',
      passwordDescription: 'Mantén el teu compte segur actualitzant la teva contrasenya regularment.',
      changePassword: 'Canviar',
      changeAvatar: 'Canviar Avatar',
      avatarModalTitle: 'Canviar Avatar',
      avatarUrlLabel: "URL de l'avatar",
      avatarUrlPlaceholder: 'https://exemple.com/avatar.jpg',
      avatarUrlInfo: "Introdueix l'URL d'una imatge per actualitzar el teu avatar.",
      passwordModalTitle: 'Canviar Contrasenya',
      currentPassword: 'Contrasenya actual',
      currentPasswordPlaceholder: 'Introdueix la teva contrasenya actual',
      newPassword: 'Nova contrasenya',
      newPasswordLabel: 'Nova contrasenya',
      newPasswordPlaceholder: 'Introdueix la nova contrasenya',
      confirmPassword: 'Confirmar nova contrasenya',
      confirmPasswordPlaceholder: 'Confirma la nova contrasenya',
      passwordRequirements: 'Requisits de la contrasenya',
      passwordMinLength: 'Almenys 8 caràcters',
      passwordUppercase: 'Una lletra majúscula (recomanat)',
      passwordNumber: 'Un número (recomanat)',
      passwordStrengthWeak: 'Feble',
      passwordStrengthMedium: 'Mitjana',
      passwordStrengthGood: 'Bona',
      passwordStrengthExcellent: 'Excel·lent',
      save: 'Guardar',
      cancel: 'Cancel·lar',
      themeXperienceIQ: 'XperienceIQ',
      themeDark: 'Fosc',
      themeSemiDark: 'Semi-fosc',
      themeLight: 'Clar',
      themeXperienceIQDesc: 'Tema oficial de XperienceIQ',
      themeDarkDesc: 'Tema fosc amb tons grisos',
      themeSemiDarkDesc: 'Tema intermedi equilibrat',
      themeLightDesc: 'Tema clar i lluminós',
      languageSpanish: 'Español',
      languageCatalan: 'Català',
      languageSpanishDesc: 'Interfaz en español',
      languageCatalanDesc: 'Interfície en català',
      avatarUpdated: 'Avatar actualitzat correctament',
      avatarUpdateError: "Error en actualitzar l'avatar",
      passwordUpdated: 'Contrasenya actualitzada correctament',
      passwordUpdateError: 'Error en actualitzar la contrasenya',
      passwordMismatch: 'Les contrasenyes no coincideixen',
      themeUpdated: 'Tema actualitzat correctament',
      themeUpdateError: 'Error en actualitzar el tema',
      languageUpdated: 'Idioma actualitzat correctament',
      languageUpdateError: "Error en actualitzar l'idioma"
    },
    dashboard: {
      filterToday: 'Avui',
      filterCurrentMonth: 'Mes actual',
      filterLast3Months: 'Últims 3 mesos',
      noClientTitle: 'Cap client seleccionat',
      noClientSubtitle: 'Selecciona un client des del menú lateral per visualitzar el seu dashboard',
      noClientHint: 'Utilitza el selector de clients del menú',
      clickForDetails: 'Clica per veure detalls',
      collaboratorsDetail: 'Detall col·laboradors',
      collaboratorColumn: 'Col·laborador',
      productionColumn: 'Producció (€)',
      percentageColumn: 'Percentatge (%)',
      totalLabel: 'Total:',
      distributionChart: 'Gràfic de distribució',
      tableTab: 'Taula',
      chartTab: 'Gràfic',
      closeButton: 'Tancar',
      monthlyComparison: 'Comparació mensual per col·laborador',
      collaboratorsAxis: 'Col·laboradors',
      productionAxis: 'Producció (€)'
    },
    appDownload: {
      title: 'Descarregar App',
      subtitle: "Descarrega l'aplicació mòbil de XperienceIQ per accedir a totes les funcionalitats des del teu dispositiu",
      android: 'Android',
      ios: 'iOS',
      note: "Els enllaços són de mostra. Substitueix-los pels enllaços reals de la botiga d'aplicacions."
    }
  }
}

export default text
